import {PolicyLimitType} from '@toolify/server/src/models/mongoose/PlanModel/enum/PolicyLimitType'
import {IconNameType} from '@toolify/server/src/enum/IconNameType'

export const policyLimitTypeIconMap: Record<PolicyLimitType, IconNameType> = {
  [PolicyLimitType.ActivityLogRetentionDays]: IconNameType.ClockRotateLeft,
  [PolicyLimitType.MaxRecordsPerDatabase]: IconNameType.Table,
  [PolicyLimitType.MaxDatabases]: IconNameType.Database,
  [PolicyLimitType.StorageMegabytes]: IconNameType.FloppyDisk,
  [PolicyLimitType.MaxUsers]: IconNameType.Users,
  [PolicyLimitType.MaxGuests]: IconNameType.User,
  [PolicyLimitType.SlaPercent]: IconNameType.Shield,
}

export const policyLimitTypeTranslationKeyMap: Record<PolicyLimitType, string> = {
  [PolicyLimitType.ActivityLogRetentionDays]: 'workspaces.usageByType.activityLogRetentionDays',
  [PolicyLimitType.MaxRecordsPerDatabase]: 'workspaces.usageByType.maxRecordsPerDatabase',
  [PolicyLimitType.MaxDatabases]: 'workspaces.usageByType.maxDatabases',
  [PolicyLimitType.StorageMegabytes]: 'workspaces.usageByType.storageMegabytes',
  [PolicyLimitType.MaxUsers]: 'workspaces.usageByType.maxUsers',
  [PolicyLimitType.MaxGuests]: 'workspaces.usageByType.maxGuests',
  [PolicyLimitType.SlaPercent]: 'workspaces.usageByType.slaPercent',
}

export const policyLimitTypeIncludedQuantityTranslationKeyMap: Partial<Record<PolicyLimitType, string>> = {
  [PolicyLimitType.MaxRecordsPerDatabase]: 'workspaces.usageByType.includedQuantity.maxRecordsPerDatabase',
  [PolicyLimitType.MaxDatabases]: 'workspaces.usageByType.includedQuantity.maxDatabases',
  [PolicyLimitType.StorageMegabytes]: 'workspaces.usageByType.includedQuantity.storageMegabytes',
}

export const policyLimitTypeLimitOnlyTranslationKeyMap: Partial<Record<PolicyLimitType, string>> = {
  [PolicyLimitType.ActivityLogRetentionDays]: 'workspaces.usageByType.includedQuantity.activityLogRetentionDays',
  [PolicyLimitType.MaxUsers]: 'workspaces.usageByType.includedQuantity.maxUsers',
}

export const policyLimitTypeOrder: PolicyLimitType[] = [
  PolicyLimitType.MaxDatabases,
  PolicyLimitType.StorageMegabytes,
  PolicyLimitType.ActivityLogRetentionDays,
  PolicyLimitType.MaxUsers,
]
